/**
 * 充值档列表视图
 */
import React, {Component} from 'react';
import notification from 'c-notification';
import lang from '../../../lang';
import Item from './option-item';
import Popup from '../popup/common-popup';
import IcardConfirmDialog from '../popup/icard-confirm';

class OptionListView extends Component {

    static defaultProps = {
        onSelectPay() {}
    };

    constructor(props) {
        super(props);

        this.state = {
            list: props.list,
            selection: props.list[0],
            showQrcode: props.showQrcode,
            qrcodeUrl: '',
            remainTime: 0
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.showQrcode !== nextProps.showQrcode )  {
            this.setState({
                showQrcode: nextProps.showQrcode,
                qrcodeUrl: nextProps.qrcodeUrl
            }, function() {
                if (this.state.showQrcode == 1) {
                    $('#wxQrPay').qrcode({
                        text: nextProps.qrcodeUrl,
                        width: 200,
                        height: 200,
                        render: 'canvas'
                    });

                    this.scrollQrcodeIntoView();
                }
            });
        }   

        this.setState({
            remainTime: nextProps.remainTime
        });
    }

    scrollQrcodeIntoView() {
        let nodeScroll = $('#rechargeScroller');

        if (nodeScroll) {

            let nodeEl = $('#wxQrPay');
            let topPos = nodeEl.offset().top;

            if (nodeScroll.attr('data-type') == 'page') {
                $(window).scrollTop(topPos);
            } else {
                nodeScroll.scrollTop(topPos);
            }
        }
    }

    onSelectPay=(data) =>{
        if (this.state.showQrcode == 1) {
            return;
        }
        this.setState({
            selection: data
        });
    }

    handleOrder=(e)=>{
        
        if( !UP.Global.isRegisterRealUser() ){
            return $.channel.emit('login');
        }
        /*----  埋点 ---*/
        UP.Global.DA.add({
            eventName: 'UplivePayment',
            action: 'ClickOrderButton',
            label: this.props.channel,
            value: this.state.selection.amount
        });

        let nodeScroll = $('#rechargeScroller');

        if (nodeScroll) {
            const item = this.state.selection;
            const paymentValue = {
                channel: this.props.channel,
                amount: item.amount,
                money: item.money,
                currency: item.currency
            }
            if (nodeScroll.attr('data-type') == 'page') {
                UP.Global.DA.add({
                    eventName: 'RechargeDesktopPayment',
                    action: 'Payment Request',
                    label: JSON.stringify(paymentValue)
                });
            } else {
                UP.Global.DA.add({
                    eventName: 'TopupDesktopPayment',
                    action: 'Payment Request',
                    label: JSON.stringify(paymentValue)
                });
            }

            fbq('track', 'UplivePayment', { 
                channel: this.props.channel,
                amount: item.amount,
                money: item.money,
                currency: item.currency
            });

        }
        /*----  埋点 ---*/
        
        this.props.onSelectPay(this.state.selection);
    }

    // icardSubmitOrder = (e)=>{
    //     let type = $(this.refs.icardtype).val().trim();
    //     let value = $(this.refs.icardvalue).val().trim();
    //     let serial = $(this.refs.icardserial).val().trim();
    //     let code = $(this.refs.icardcode).val().trim();
    //
    //
    //     if (!serial) {
    //
    //         notification.simple("Please enter serial of the card");
    //         return;
    //     }
    //
    //     if (!code) {
    //         notification.simple("Please enter code of the card");
    //         return;
    //     }
    //
    //     this.props.onSelectPay(this.state.list[0], {
    //         cardType: type,
    //         cardValue: value,
    //         serial: serial,
    //         code: code
    //     });
    // }

    // get the text content of selected option
    getSelectedText(selectEl) {
        return selectEl.options[selectEl.selectedIndex].text;
    }

    icardSubmitOrder = (e)=>{
        if(!UP.Global.isRegisterRealUser()){
            return $.channel.emit('login');
        }
        let self = this;
        let $icardType = $(this.refs.icardtype);
        let $icardValue = $(this.refs.icardvalue);
        let type = $(this.refs.icardtype).val().trim();
        let value = $(this.refs.icardvalue).val().trim();
        let serial = $(this.refs.icardserial).val().trim();
        let code = $(this.refs.icardcode).val().trim();

        if (!serial) {

            notification.simple("Please enter serial of the card");
            return;
        }

        if (!code) {
            notification.simple("Please enter code of the card");
            return;
        }

        const contextProps = {
            type: this.getSelectedText($icardType[0]),
            value: this.getSelectedText($icardValue[0]),
            serial,
            code
        };

        Popup.create(contextProps, IcardConfirmDialog, function(status) {
            if (status === 'confirm') {
                self.props.onSelectPay(self.state.list[0], {
                    cardType: type,
                    cardValue: value,
                    serial: serial,
                    code: code
                });
            }
        });

    }

    onChangeIcardType=(e)=>{
        let value = e.currentTarget.value;

        if (value ==  1) {
            this.refs.icardvalue.value = '50000';
            $(this.refs.icard20).addClass('hidden');
        } else {
            this.refs.icardvalue.value = '20000';
            $(this.refs.icard20).removeClass('hidden');
        }
    }

    onChangeIcardValue=(e)=>{
        let value = e.currentTarget.value;
        console.log(value);
    }

    render() {
        let { selection, list } = this.state;
        let { channel } = this.props;
        let $list = [];
        let $extraHtml;
        let $button;
        let $tip;

        list.forEach((item, index) => {
            let selectedCls = selection.configId == item.configId ? 'selected' : '';

            $list.push(<li className={selectedCls} key={index}><Item data={item} onSelectPay={this.onSelectPay} /></li>);
        });

        if (channel == 'wxpay' && this.state.showQrcode == 1) {
            $extraHtml = (
                <div className="qrcode-pay">
                    <div className="hd" dangerouslySetInnerHTML={{ __html: lang.template('距离二维码过期还剩<%=count%>秒，过期后请刷新页面重新获取二维码', {count: this.state.remainTime}, 1) }}></div>
                    <div className="bd">
                        <div className="qrcode">
                            <i id="wxQrPay"></i>
                        </div>
                        <div className="tip">
                            <i></i>
                            <em dangerouslySetInnerHTML={{ __html: lang.template("请使用微信扫一扫<br/>扫描二维码支付") }}></em>
                        </div>
                    </div>
                </div>
            )
        } 

        // cashcard点卡充值，显示页面结构不同于其他渠道

        if (channel == 'pepay_entitycard_thb' || channel == 'pepay_entitycard_vnd' || channel == 'gash_card') {
            let real, number, sybol;
            
            if (list[0]) {
                [real, number] = list[0].proportion.split(':');
                sybol = list[0].currencySymbol.toUpperCase();
            }

            $list = (
                <div className="option-list cashcard">
                    <h3 className="tips">{lang.template('小贴士')}</h3>
                    <div className="spectip">
                        <p className="cash"><em>1.</em> {lang.template('使用CashCard充值的金额数以点卡实际支付的金额为准')}</p>
                        <p className="cash"><em>2.</em> {lang.template('使用CashCard充值所得U钻数将根据兑换比例(<%=currence%><%=real%>=<%=number%>钻)进行换算，最终所得U钻数会进行四舍五入处理', {real,currence:sybol,number})}</p>
                    </div>
                </div>
            );

            $tip  = <div className="money" ><label>{lang.template('充值比例: <%=currence%><%=real%>=<%=number%>U钻', {real,currence: sybol,number})}</label></div>
        }

        if (channel == 'icard') {
            let real, number, sybol;
            
            if (list[0]) {
                [real, number] = list[0].proportion.split(':');
                sybol = list[0].currencySymbol.toUpperCase();
            }

            $list = (
                <div className="option-list cashcard">
                    <div className="recharge-icard">
                    
                        <div className="item-wrap">
                            <label>CardType:</label>
                            <div className="input-wrap">
                                <select ref="icardtype" onChange={this.onChangeIcardType}>
                                    <option value="2">Mobifone</option>
                                    <option value="1">Viettel</option>
                                    <option value="3">Vinaphone</option>
                                </select>
                                <div className="expand-arrow"></div>
                            </div>
                        </div>
                        <div className="item-wrap">
                            <label>CardValue:</label>
                            <div className="input-wrap">
                                <select ref="icardvalue" onChange={this.onChangeIcardValue}>
                                    <option value="20000" ref="icard20">20.000</option>
                                    <option value="50000">50.000</option>
                                    <option value="100000">100.000</option>
                                    <option value="200000">200.000</option>
                                    <option value="500000">500.000</option>
                                </select>
                                <div className="expand-arrow"></div>
                            </div>
                        </div>
                        <div className="item-wrap">
                            <label>Serial:</label>
                            <div className="input-wrap">
                                <input name="serial" ref="icardserial" type="text" placeholder="Please enter serial of the card"  autoComplete="off"/>
                            </div>
                        </div>
                        <div className="item-wrap">
                            <label>Code:</label>
                            <div className="input-wrap">
                                <input name="code" ref="icardcode" type="text" placeholder="Please enter code of the card" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                </div>
            );

            $tip  = <div className="money" ><label>{lang.template('充值比例: <%=currence%><%=real%>=<%=number%>U钻', {real,currence: sybol,number})}</label></div>
        }

        if (this.state.showQrcode == 1) {
            $button = null;    
        } else {
            if (channel == 'icard') {
                $button = <button className="btn_pay" onClick={this.icardSubmitOrder}>{lang.template('立即充值')}</button>
            } else {
                $button = <button className="btn_pay" onClick={this.handleOrder}>{lang.template('立即充值')}</button>
            }
        }
        

        return (
            <div className="recharge-form">
                <ul className="option-list clearfix">
                    {$list}
                </ul>
                <div className="recharge-bar clearfix">
                    {
                        ['pepay_entitycard_thb', 'pepay_entitycard_thb', 'icard', 'gash_card'].indexOf(channel) > -1 ? $tip : (
                            <div className="money">
                                <label>{lang.template('应付金额')}  </label>
                                <em>{selection.currencySymbol}{ selection.money / 100 }</em>
                            </div>
                        ) 
                    }
                    { $button }
                </div>
                { $extraHtml }
            </div>
        );
    }
};

export default OptionListView;



// WEBPACK FOOTER //
// ./js/component/recharge/orderview/option-list-view.js